import axios from 'axios';
import { Modal } from 'bootstrap';
import { mount } from '../dom-lifecycle';

mount('[data-receipt-flow-modal]', function (el, refs, emit) {
    const flowModal = Modal.getOrCreateInstance(el);

    const history = [];
    let billData = {};
    let receiptUuid = null;
    let acceptUrl = null;
    let scriptClose = false;

    let progressTimer = null;
    let progressValue = 0;

    function stopProgress() {
        clearInterval(progressTimer);
        progressTimer = null;
    }

    function startProgress() {
        stopProgress();
        progressValue = 0;
        refs.progress.textContent = '0%';
        progressTimer = setInterval(() => {
            progressValue += (90 - progressValue) * 0.04;
            refs.progress.textContent = `${Math.round(progressValue)}%`;
        }, 120);
    }

    function finishProgress() {
        return new Promise(resolve => {
            stopProgress();
            progressTimer = setInterval(() => {
                progressValue += Math.max(2, (100 - progressValue) * 0.3);
                if (progressValue >= 100) {
                    stopProgress();
                    refs.progress.textContent = '100%';
                    setTimeout(resolve, 200);
                    return;
                }
                refs.progress.textContent = `${Math.round(progressValue)}%`;
            }, 40);
        });
    }

    // Bootstrap ignoruje hide() w trakcie animacji otwierania (`if (!this._isShown ||
    // this._isTransitioning) return`). Błąd, który wraca szybciej niż ~300 ms - a odrzucony przez
    // walidację plik wraca po ~240 ms, bez odpytywania paragoniusza - zostawiał więc modal otwarty
    // na zawsze: strona `loading` blokuje backdrop i klawiaturę, więc user nie miał jak wyjść.
    let transitioning = false;
    el.addEventListener('show.bs.modal', () => transitioning = true);
    el.addEventListener('shown.bs.modal', () => transitioning = false);

    function hide() {
        stopProgress();
        if (transitioning) {
            el.addEventListener('shown.bs.modal', hide, { once: true });
            return;
        }
        scriptClose = true;
        flowModal.hide();
    }

    el.addEventListener('hidden.bs.modal', () => {
        if (!scriptClose) emit('receipt:abort');
        scriptClose = false;
    });

    function renderPage(name) {
        const locked = name == 'loading';
        flowModal._config.backdrop = locked ? 'static' : true;
        flowModal._config.keyboard = !locked;
        refs.all.page.forEach(page => page.hidden = page.dataset.page !== name);
        el.scrollTo({ top: 0, behavior: 'smooth' });
        flowModal.show();
    }

    function showPage(name) {
        const current = [...refs.all.page].find(page => !page.hidden);
        if (current && current.dataset.page !== name) history.push(current.dataset.page);
        renderPage(name);
    }

    function goBack() {
        // Wymuszony formularz ręczny nie ma ekranu, na który da się wrócić (ekran błędu jest już
        // zamknięty). „Powrót" musi wtedy przerwać flow tak, jak zamknięcie modala krzyżykiem:
        // bez tego user zostawał ze zgłoszeniem, w którym paragon istnieje, ale nie ma danych.
        if (!history.length) {
            flowModal.hide();
            return;
        }
        renderPage(history.pop());
    }

    function showReject(type, manual) {
        if (type == 'urn:receipt:duplicate') {
            showPage('duplicate');
            return;
        }
        refs.rejectedTitleAuto.hidden = manual;
        refs.rejectedTitleManual.hidden = !manual;
        showPage('rejected');
    }

    function fillPreview(data) {
        for (const [name, value] of Object.entries(data)) {
            const cell = refs[`preview-${name}`];
            if (!cell) continue;
            if (name == 'billAmount') cell.textContent = value > 0 ? 'TAK' : 'NIE';
            else cell.textContent = value ?? '—';
        }
    }

    refs.btnAccept.addEventListener('click', async (e) => {
        e.target.disabled = true;
        try {
            await axios.post(acceptUrl.replace('__uuid__', receiptUuid));
        } catch (error) {
            showReject(error.response?.data?.type, false);
            return;
        } finally {
            e.target.disabled = false;
        }
        hide();
    });

    refs.btnManual.addEventListener('click', () => showPage('manual-warning'));

    function fillForm() {
        for (const field of refs.form.elements) {
            if (!field.name || billData[field.name] == null) continue;
            // Checkboksy (produkt promocyjny) startują ze stanem z odczytu OCR —
            // `value` na checkboksie nie zmienia zaznaczenia, więc trzeba `checked`.
            if (field.type === 'checkbox') field.checked = Boolean(billData[field.name]);
            else field.value = billData[field.name];
            // Przypisanie z JS-a nie emituje zdarzeń, a walidatory pól (maski
            // w form/attributes.js, reguły data-type) przeliczają się wyłącznie
            // na `input`/`change`. Bez tego pole ma widoczną wartość, ale IMask
            // nadal uważa je za niekompletne i formularz zgłasza „Podaj…".
            field.dispatchEvent(new Event('input', { bubbles: true }));
            field.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    /** Przełącza nagłówki formularza: korekta poprawnego odczytu vs uzupełnienie brakujących danych. */
    function setManualMode(forced, notice) {
        refs.manualHeaderReview.hidden = forced;
        refs.manualHeaderForced.hidden = !forced;
        refs.manualIntroReview.hidden = forced;
        refs.manualNotice.textContent = notice ?? '';
        refs.manualNotice.hidden = !notice;
    }

    refs.btnManualContinue.addEventListener('click', () => {
        fillForm();
        setManualMode(false, null);
        showPage('manual-form');
    });

    $(refs.form).on('submit-success', (event, data) => {
        const values = Object.fromEntries(new FormData(refs.form));
        delete values._token;
        billData = { ...billData, ...values };
        // O treści podziękowania decyduje backend, nie to, że user był na formularzu: korekta
        // nieodczytanego paragonu, która nie podnosi deklaracji, jest akceptowana automatycznie.
        emit('receipt:data', { values, manual: data?.requiresVerification ?? true });
        hide();
    });
    $(refs.form).on('submit-error', (event, xhr) => {
        event.preventDefault();
        showReject(xhr.responseJSON?.type, true);
    });

    refs.all.btnBack.forEach(button => button.addEventListener('click', goBack));
    refs.all.btnRetry.forEach(button => button.addEventListener('click', () => emit('receipt:retry')));
    refs.all.btnHelp.forEach(button => button.addEventListener('click', () => showPage('help')));

    return {
        loading: () => {
            //refs.dataPreview.innerHTML = '';
            startProgress();
            showPage('loading');
        },
        appendPreview: (text) => {
            //refs.dataPreview.innerHTML += text.replace('\n', '<br />');
            //refs.dataPreview.scrollTop = refs.dataPreview.scrollHeight;
        },
        analyzed: async ({ billData: data, receiptUuid: uuid, acceptUrl: accept, verifyUrl }) => {
            billData = data;
            receiptUuid = uuid;
            acceptUrl = accept;
            refs.form.action = verifyUrl.replace('__uuid__', uuid);
            fillPreview(data);
            await finishProgress();
            showPage('preview');
        },
        error: async (variant = 'api_down') => {
            refs.all.errorVariant.forEach(block => block.hidden = block.dataset.errorVariant !== variant);
            // Nieznany wariant nie może dać pustej karty bez treści.
            if (![...refs.all.errorVariant].some(block => !block.hidden)) {
                refs.all.errorVariant.forEach(block => block.hidden = block.dataset.errorVariant !== 'api_down');
            }
            await finishProgress();
            showPage('error');
        },
        /**
         * Odczyt się nie udał, ale user wyczerpał próby poprawy zdjęcia (albo padło API) —
         * wpuszczamy go na formularz z tym, co udało się odczytać. Historia jest czyszczona,
         * bo nie ma sensownego ekranu „wstecz": „Powrót" przerywa całe dodawanie.
         */
        manual: async ({ billData: data, receiptUuid: uuid, verifyUrl, notice }) => {
            billData = data;
            receiptUuid = uuid;
            refs.form.action = verifyUrl.replace('__uuid__', uuid);
            fillForm();
            setManualMode(true, notice);
            await finishProgress();
            history.length = 0;
            renderPage('manual-form');
        },
        hide,
    };
});
